import React from 'react';
import { ChevronRight, NotebookText } from 'lucide-react';
import { formatDayMonth } from '@/lib/formatDate';
import { usePatientAgentContext } from './usePatientAgentContext';
import { usePatientContextSheet } from './PatientContextSheet';

// One line for the bar: markdown markers and line breaks dropped.
export function contextPreview(text: string): string {
  return text
    .replace(/\*\*/g, '')
    .replace(/^\s*[-*•]\s+/gm, '')
    .replace(/\s+/g, ' ')
    .trim();
}

// Under a patient conversation's header: the start of the clinical context
// Sissi is using, and the way into it without leaving the chat.
const PatientContextChip: React.FC<{ patient: { id: number; name: string } }> = ({ patient }) => {
  const { context } = usePatientAgentContext(patient.id);
  const sheet = usePatientContextSheet();
  const preview = context?.text ? contextPreview(context.text) : '';

  return (
    <button
      type="button"
      onClick={() => sheet?.openContextSheet(patient)}
      className="flex w-full min-w-0 cursor-pointer items-center gap-2 rounded-[9px] border border-border bg-muted px-2.5 py-1.5 text-left text-[13px] hover:bg-accent"
    >
      <NotebookText className="size-3.5 shrink-0 text-muted-foreground" aria-hidden="true" />
      <span className="min-w-0 flex-1 truncate">
        <strong className="font-semibold">Contexto clínico:</strong>{' '}
        {context &&
          (preview ? (
            <span>{preview}</span>
          ) : (
            <span className="text-muted-foreground">vacío. Añade lo que Sissi AI debe saber de este paciente.</span>
          ))}
      </span>
      {context?.text && (
        <span className="shrink-0 font-mono text-xs text-muted-foreground">
          v{context.version}
          {context.updatedAt ? ` · ${formatDayMonth(context.updatedAt)}` : ''}
        </span>
      )}
      <ChevronRight className="size-3.5 shrink-0 text-muted-foreground" aria-hidden="true" />
    </button>
  );
};

export default PatientContextChip;
